if (typeof Shopify !== 'undefined' && !Shopify.previewMode) {
  const getCountryForAuto = async () => {
    // Return cached value if we have one for this session
    const cached = sessionStorage.getItem('visitorLocation');
    if (cached) return cached;
  
    let location = null;
  
    try {
      const res = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
      const text = await res.text();
      const data = Object.fromEntries(text.trim().split('\n').map(l => l.split('=')));
      if (data.loc) location = data.loc;
    } catch (e) {}
  
    if (!location) {
      try {
        const res = await fetch('https://ipwho.is/');
        const data = await res.json();
        if (data.country_code) location = data.country_code;
      } catch (e) {}
    }
  
    if (location) {
      sessionStorage.setItem('visitorLocation', location);
    }
  
    return location; // null if both failed
  };
  
  (async () => {
    const visitorLocation = await getCountryForAuto();
    const currentLocation = Shopify.country;
    const origin = window.location.origin;
    const currentPathname = window.location.pathname;
    const targetUSPathname = '/en-us';
    const supportedLocales = ['en-us'];
  
    if ((visitorLocation === 'US' && currentLocation === 'GB') || (visitorLocation === 'GB' && currentLocation === 'US')) {
      let newPath;
  
      if (visitorLocation === 'US' && currentLocation === 'GB') {
        // Add locale prefix if not present
        if (!currentPathname.includes(targetUSPathname)) {
          newPath = `${origin}${targetUSPathname}${currentPathname}`;
        }
      } else if (visitorLocation === 'GB' && currentLocation === 'US') {
        // Remove locale prefix
        const segments = currentPathname.split('/').filter(Boolean);
        const firstSegment = segments[0];
  
        if (supportedLocales.includes(firstSegment)) {
          newPath = `${origin}/${segments.slice(1).join('/')}`;
        }
      }
  
      if (newPath) {
        // Preserve query params and hash
        const search = window.location.search;
        const hash = window.location.hash;
        const fullPath = newPath + search + hash;
  
        window.location.href = fullPath;
      }
    }
  })();
}